// var paywall = require("./lib/paywall");
// setTimeout(() => paywall(12345678), 5000);

require("component-responsive-frame/child");

require('waypoints/lib/noframework.waypoints.min');

// var IScroll = require('iscroll');

// var IScroll = require('./iscroll-probe.js');
const $ = require('jquery');

var lastScrollTop = 0;

let currentPage = 0;

var myScroll = "hi";

history.scrollRestoration = "manual";

// var dotClick = false;

window.onbeforeunload = function () {
  window.scrollTo(0, 0);
}

		$( document ).ready(function() {

      $( ".dotContainer .dot" ).click(function() {
      	  $( ".dotContainer .dot" ).removeClass( "active" );
      		$(this).addClass("active");
      		var classList_hope = $(this).attr("class").split(/\s+/);
      		console.log(classList_hope);
      		myScroll.scrollToElement(`#${classList_hope[1]}`);

      });

			$( "#table-of-contents .toc_link" ).click(function() {
				var classList_hope = $(this).attr("class").split(/\s+/);
				if (viewportWidth > 600) {
				// myScroll.scrollToElement(`#${classList_hope[1]}`);
        $([document.documentElement, document.body]).animate({
            scrollTop: $(`#${classList_hope[1]}`).offset().top
        }, 1000);
			} else {
				$([document.documentElement, document.body]).animate({
						scrollTop: $(`#${classList_hope[1]}`).offset().top
				}, 1000);
			}

			});

			$( "#backToToc" ).click(function() {
				if (viewportWidth > 600) {
				// myScroll.scrollToElement(`#table-of-contents`);
        $([document.documentElement, document.body]).animate({
            scrollTop: $('#table-of-contents').offset().top
        }, 1000);
				} else {
					$([document.documentElement, document.body]).animate({
							scrollTop: $('#table-of-contents').offset().top
					}, 1000);
				}
			});

			// .scrollToElement("h2");



			// On resize events, recalculate and log
			window.addEventListener('resize', function () {
				setViewportWidth();
				logWidth();
			}, false);

			const allNodes = document.querySelectorAll('.dotContainer .dot');

			var goBig = function () {
			// startNode = allNodes[0];
			// startNode.classList.add("active");

		  // myScroll = new IScroll('#wrapper',{
		  //     mouseWheel: true,
		  //     scrollbars: false,
		  //     keyBindings: true,
		  //     momentum: false,
		  //     probeType: 2,
		  //     bounceEasing: {
		  //         style: 'cubic-bezier(0.77, 0, 0.175, 1)',
		  //         fn: function (k) { return k; }
		  //     },
		  //     mouseWheelSpeed: 1,
		  //     scrollX: false,
		  // 	  scrollY: true,
		  //     snap: 'div>.specialBlock'
		  //   });
		  //   document.addEventListener('touchmove', function (e) {
			// 		console.log(hi);
			// 		e.preventDefault();
			// 	}, false);

				// myScroll.on ('scrollEnd', function () {
				//   console.log(myScroll.currentPage.pageY);
				// currentPage = myScroll.currentPage.pageY;
				// allNodes.forEach(el => el.classList.remove('active'));
				//
				// let nextDot = allNodes[currentPage];
				// nextDot.classList.add("active");
				// });

				// myScroll.on ('scrollEnd', function () {
				//
				// });



			};

			// Log the viewport width into the console
			var logWidth = function () {
        goLittle();
				if (viewportWidth > 600) {
					// setTimeout(() => {
					//   goBig();
					// }, 500);
          console.log('Small viewport');

				} else {
					console.log('Small viewport');
					// goLittle();
				}
			}


			var goLittle = function () {
			  $('.specialBlock').each((index, element) => {

			    $(element).ready(function() {
			      new Waypoint({
			          element: element,
			          handler: function(direction) {
			            if(direction === "down") {
			              let chosenID = $(element).attr('id');
										$('.dotContainer .dot').removeClass("active");
			              $('.dotContainer').find(`.${chosenID}`).addClass("active");
			            } else if (direction === "up") {
			              let chosenID = $(element).attr('id');
										$('.dotContainer .dot').removeClass("active");
			              $('.dotContainer').find(`a[href*="#${chosenID}"]`).prev().find('.dot').addClass('active');
			            }
			          },
			          offset: '20%'
			          });
			    });
			  });
			}


			// Define our viewportWidth variable
			var viewportWidth;

			// Set/update the viewportWidth value
			var setViewportWidth = function () {
				viewportWidth = window.innerWidth || document.documentElement.clientWidth;
			}


			// Set our initial width and log it
			setViewportWidth();
			logWidth();

		});












  // function makeVideoWaypoints(blockHeight) {
  //   $('.specialBlock').each((index, element) => {
  //     console.log(index);
	//
  //     $(element).ready(function() {
  //       new Waypoint({
  //           element: element,
  //           handler: function(direction) {
  //             if(direction === "down") {
  //               $('.bigMama').css("transform",`translate3d(0px, ${blockHeight * -1 * (index)}px, 0px)`);
  //               console.log('hi');
  //             } else if (direction === "up") {
	//
  //             }
  //           },
  //           offset: '20%'
  //           });
  //     });
  //   });
  // };

//   let height = $( '.specialBlock' ).height();
//   console.log(height);
//   var numItems = $('.specialBlock').length;
//   var counter = 0;
//   console.log(numItems);
//
//   $('body').bind('DOMMouseScroll mousewheel', function(e){
//     if(e.originalEvent.wheelDelta > 0) {
//         console.log('scrolling up !');
//     }
//     else{
//         console.log('scrolling down !');
//     }
// });

  // $(window).scroll(function(event){
  //    var st = $(this).scrollTop();
  //    if (st > lastScrollTop){
  //        // downscroll code
  //        console.log(st);
  //        // $('.bigMama').css("transform",`translate3d(0px, ${height * -1 * (counter)}px, 0px)`);
  //        // counter = counter < 3 ? counter + 1 : counter;
  //    } else {
  //       // upscroll code
  //    }
  //    lastScrollTop = st;
  // });


	// Select all links with hashes
	// $('[data-link]')
	//   // Remove links that don't actually link to anything
	//   .not('[href="#"]')
	//   .not('[href="#0"]')
	//   .click(function(event) {
	// 		var target = $(this).data('link');
	// 		const myArray = text.split(" ");
	// 		console.log(target.replace(/^\//, ''));
	//     // On-page links
	//     // if (
	//     //   location.pathname.replace(/^\//, '') == target.replace(/^\//, '')
	//     //   &&
	//     //   location.hostname == this.hostname
	//     // ) {
	//       // Figure out element to scroll to
	//       // var target = $(this.hash);
	// 			// console.log(target);
	//       target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
	//       // Does a scroll target exist?
	//       if (target.length) {
	//         // Only prevent default if animation is actually gonna happen
	//         event.preventDefault();
	//         $('html, body').animate({
	//           scrollTop: target.offset().top
	//         }, 1000, function() {
	//           // Callback after animation
	//           // Must change focus!
	//           var $target = $(target);
	//           $target.focus();
	//           if ($target.is(":focus")) { // Checking if the target was focused
	//             return false;
	//           } else {
	//             $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
	//             $target.focus(); // Set focus again
	//           };
	//         });
	//       }
	//     // }
	//   });


  // makeVideoWaypoints(height);
